import {
  SecondsSpan,
  TotalTimeText,
} from "../../styledComponents/timesheet";

export const TimeDisplay = ({ timeString , marginLeft }) => {
  if (!timeString || timeString === '-') return <TotalTimeText  marginLeft={marginLeft}>-</TotalTimeText>;

  const hasHours = timeString.includes("h");
  const hasMinutes = timeString.includes("m");
  const hasSeconds = timeString.includes("s");

  // Extract parts
  const parts = timeString.split(" ");
  const hoursPart = parts.find(p => p.includes("h")) || "";
  const minutesPart = parts.find(p => p.includes("m")) || "";
  const secondsPart = parts.find(p => p.includes("s")) || "";

  // Case 1: only seconds
  if (hasSeconds && !hasHours && !hasMinutes) {
    return <TotalTimeText marginLeft={marginLeft}>{secondsPart}</TotalTimeText>;
  }

  // Case 2: hours/minutes + maybe seconds
  return (
    <TotalTimeText marginLeft={marginLeft}>
      {hoursPart && `${hoursPart} `}
      {minutesPart && `${minutesPart}`}
      {hasSeconds && <SecondsSpan>{secondsPart}</SecondsSpan>}
    </TotalTimeText>
  );
};